"use client";
import React from "react";
import {
  Plus,
  MagnifyingGlass,
  FunnelSimple,
  PencilSimple,
  Trash,
} from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import AddCategory from "@/components/custom/categories/AddCategory";

const WarrantiesPage = () => {
  const warranties = [
    {
      id: "CAT001",
      name: "Smartphone X",
      category: "Electronics",
      price: 328.85,
      stock: 20,
      status: "Active",
    },
    {
      id: "CAT002",
      name: "Designer T-Shirt",
      category: "Clothing",
      price: 54.08,
      stock: 50,
      status: "Active",
    },
    {
      id: "CAT003",
      name: "Wireless Earbuds",
      category: "Electronics",
      price: 106.58,
      stock: 5,
      status: "Low Stock",
    },
    {
      id: "CAT004",
      name: "Running Shoes",
      category: "Footwear",
      price: 82.01,
      stock: 0,
      status: "Out of Stock",
    },
    {
      id: "CAT005",
      name: "Coffee Maker",
      category: "Home Appliances",
      price: 202.87,
      stock: 15,
      status: "Active",
    },
  ];

  return (
    <div className="container mx-auto bg-white dark:bg-slate-900 p-6 min-h-screen">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Warranties</h1>

        <AddCategory />
      </div>

      <div className="mb-4">
        <div className="flex justify-between">
          <div className="relative">
            <Input
              className="pl-8 bg-gray-800 text-white"
              placeholder="Search warranties..."
            />
            <MagnifyingGlass className="absolute left-2 top-2.5 h-5 w-5 text-gray-400 dark:text-gray-500" />
          </div>
          <Button variant="outline" className="ml-2">
            <FunnelSimple className="mr-2 h-4 w-4" /> Filter
          </Button>
        </div>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[50px]">
              <input
                type="checkbox"
                className="rounded bg-gray-800 border-gray-600"
              />
            </TableHead>
            <TableHead>Category ID</TableHead>
            <TableHead>Category Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {warranties.map((category) => (
            <TableRow key={category.id}>
              <TableCell>
                <input
                  type="checkbox"
                  className="rounded bg-gray-800 border-gray-600"
                />
              </TableCell>
              <TableCell className="font-medium">{category.id}</TableCell>
              <TableCell>{category.name}</TableCell>
              <TableCell>{category?.description}</TableCell>
              <TableCell>
                <Badge
                  className={
                    category.status === "Active"
                      ? "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400"
                      : category.status === "Low Stock"
                      ? "bg-yellow-500"
                      : "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400"
                  }
                >
                  {category.status}
                </Badge>
              </TableCell>
              <TableCell className="text-right">
                <Button variant="ghost" size="icon">
                  <PencilSimple className="h-4 w-4" />
                </Button>
                <Button variant="ghost" size="icon">
                  <Trash className="h-4 w-4" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default WarrantiesPage;
